import { DecisionTrack } from "@/constants/decision-track";

import { groupByTrack, tracksPresentIn } from "./decision-track";
import { PayrollDiscountCandidate } from "./is-payroll-discount";
import { requiresIdentity } from "./track-spec";

export interface TrackedCandidate extends PayrollDiscountCandidate {
  id: number;
}

export interface TrackedSelection<TItem extends TrackedCandidate> {
  readonly groups: Record<DecisionTrack, TItem[]>;
  readonly present: readonly DecisionTrack[];
  readonly identityIds: number[];
  readonly selfReadyIds: number[];
}

const idsOf = <TItem extends TrackedCandidate>(items: TItem[]): number[] =>
  items.map((item: TItem): number => item.id);

export const trackSelection = <TItem extends TrackedCandidate>(
  items: readonly TItem[]
): TrackedSelection<TItem> => {
  const groups: Record<DecisionTrack, TItem[]> = groupByTrack(items);
  const present: readonly DecisionTrack[] = tracksPresentIn(groups);

  const idsWhere = (needsIdentity: boolean): number[] =>
    present
      .filter(
        (track: DecisionTrack): boolean => requiresIdentity(track) === needsIdentity
      )
      .flatMap((track: DecisionTrack): number[] => idsOf(groups[track]));

  return {
    groups,
    present,
    identityIds: idsWhere(true),
    selfReadyIds: idsWhere(false),
  };
};
